import React from 'react';
import { PiCrosshairSimpleFill } from "react-icons/pi";

interface PrioritiesCardProps {
  priorities: any[];
  onSeeAll?: () => void;
}

const PrioritiesCard: React.FC<PrioritiesCardProps> = ({ priorities, onSeeAll }) => {
  return (
    <div className="border rounded-lg p-4 bg-white shadow-sm">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold">Priorities</h2>
        <button 
          className="text-blue-600 text-sm hover:text-blue-800 transition-colors cursor-pointer"
          onClick={onSeeAll}
        >
          See All →
        </button>
      </div>
      <ul className="space-y-2 text-sm">
        {priorities.slice(0, 3).map((item, index) => (
          <li key={index} className="flex items-start gap-2">
            <PiCrosshairSimpleFill className="mt-0.5 text-green-500 w-5 h-5" />
            <span>{item.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PrioritiesCard;